module.exports = "<input type=\"range\" [attr.id]=\"inputId\" [attr.min]=\"min\" [attr.max]=\"max\" [attr.value]=\"value\" [attr.readonly]=\"disabled\">\n\n<div class=\"track\" [class.dragging]=\"isDragging\" [class.disabled]=\"disabled\" tabindex=\"0\" #track>\n    <div class=\"handle\" #handle></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/viega-slider/viega-slider.component.html
// module id = pp8u
// module chunks = 5